import { router } from "./routes";
import { RouterProvider } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { TourProvider } from "@reactour/tour";
import {
  QueryClient,
  QueryClientProvider
} from "react-query";
import { Authenticator } from "@aws-amplify/ui-react";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    }
  }
});

const steps = [
  {
    selector: "#nbsInsightsButton",
    content: "This is my first Step",
  },
  {
    selector: "#nbsCareProviderButton",
    content: "This is my second Step",
  },
];

const radius = 10;

function App() {
  return (
    <HelmetProvider>
      <Helmet defaultTitle="Total Care Compass" />
      <Authenticator.Provider>
        <TourProvider
          steps={steps}
          styles={{
            popover: (base) => ({
              ...base,
              "--reactour-accent": "#ef5a3d",
              borderRadius: radius,
              minWidth: "250px",
            }),
            badge: (base) => ({
              ...base,
              backgroundColor: "white",
              color: "#104C58",
            }),
          }}
        >
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router}></RouterProvider>
          </QueryClientProvider>
        </TourProvider>
      </Authenticator.Provider>
    </HelmetProvider>
  );
}

export default App;
